h1 {

}
.explanation {
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 2em;

}

.files {
  border: .2em solid hsl(240, 100%, 50%);
  position: relative;
  left: 0;
}
.select_files_message {
  display: block;
  padding: .7em;
}

.more_info > * {
  margin: .7em 1.3em;
}

.checkbox {
  border: 0;
  background-color: unset;
}

.single_button {
  margin: .7em 1.3em;
}
